import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import './JoinUs.css';

export default function JoinUs({ navigate }) {
  // Auto-open the form in a new tab when the page loads
  useEffect(() => {
    window.open('https://forms.gle/BfGv55XhE5h7A42k9', '_blank', 'noopener,noreferrer');
  }, []);

  const FORM_URL = 'https://forms.gle/BfGv55XhE5h7A42k9';

  const perks = [
    { icon: '🌍', label: 'Global Community', desc: 'Connect with passionate musicians from 29+ nations worldwide' },
    { icon: '📚', label: 'Leadership Experience', desc: 'Build real skills running an international nonprofit initiative' },
    { icon: '🎵', label: 'Musical Impact', desc: 'Directly help students discover the transformative joy of music' },
    { icon: '⭐', label: 'Full Support', desc: 'Receive full organizational support from our global team' },
  ];

  return (
    <div className="join-page">

      {/* Hero */}
      <div className="join-hero">
        <div className="page-hero-ghost">Join</div>
        <div className="section-tag">Apply Now</div>
        <h1 className="join-hero-title">
          Join the <em>ECHO</em> Team
        </h1>
        <p className="join-hero-sub">
          We're always looking for passionate musicians and dedicated individuals to help grow our global community. Click the button below to open our application form.
        </p>
        <div className="join-hero-btns">
          <a href={FORM_URL} target="_blank" rel="noopener noreferrer" className="btn-primary join-cta-btn">
            Open Application Form →
          </a>
          <button className="btn-outline" onClick={() => navigate('home')}>
            Back to Home
          </button>
        </div>
        <p className="join-form-note">
          The form opens in a new tab. If it didn't open automatically,{' '}
          <a href={FORM_URL} target="_blank" rel="noopener noreferrer" className="join-inline-link">
            click here
          </a>.
        </p>
      </div>

      {/* Perks */}
      <section className="join-perks-section">
        <div className="section-tag">Why Join</div>
        <h2 className="section-h2">What you'll <em>gain</em></h2>
        <div className="join-perks-grid">
          {perks.map((p, i) => (
            <div key={i} className="join-perk-card">
              <div className="join-perk-icon">{p.icon}</div>
              <h3 className="join-perk-label">{p.label}</h3>
              <p className="join-perk-desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="join-bottom-cta">
        <h2 className="section-h2">Ready to make a <em>difference?</em></h2>
        <p>The form takes just a few minutes. We review applications regularly and will reach out soon.</p>
        <a href={FORM_URL} target="_blank" rel="noopener noreferrer" className="btn-primary">
          Apply Now →
        </a>
      </section>

      <Footer navigate={navigate} />
    </div>
  );
}
